import Fetch from '@/api';

const state = {
  nwVideo: false,
  showDrugDialog: false,
  prescriptionInfo: null
};

const mutations = {
  SET_NW_VIDEO(state, nwVideo) {
    state.nwVideo = !!nwVideo;
  },
  SET_SHOW_DRUG_DIALOG(state, showDrugDialog) {
    state.showDrugDialog = !!showDrugDialog;
  },
  SET_PRESCRIPTION_INFO(state, prescriptionInfo) {
    state.prescriptionInfo = prescriptionInfo;
  },
  RESET_STATE(state) {
    state.nwVideo = false;
    state.showDrugDialog = false;
    state.prescriptionInfo = null;
  }
};

const actions = {
  async save_drug_info({ state }, prescriptionDetails) {
    const {
      prescriptionInfo: { id, advisoryType }
    } = state;
    return await Fetch.append_prescription_details({
      prescriptionId: id,
      advisoryType,
      prescriptionDetails
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
